import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateCorrectExpenseItemAccountCodeInline } from '../../models/useMutateCorrectExpenseItemAccountCodeInline'

/**
 * Hook-only command presenter (ADR-2): commits a single-item account-code
 * correction immediately — no confirmation, no modal (BHV-013) — and toasts
 * the outcome (BHV-014/027).
 */
export const useCorrectExpenseItemAccountCodeInlinePresenter = () => {
  const intl = useProcurifyIntl()

  const { correctAccountCode, isLoading } =
    useMutateCorrectExpenseItemAccountCodeInline()

  const handleCorrectAccountCode = async (
    expenseItemId: number,
    accountId: number
  ) => {
    try {
      await correctAccountCode({ expenseItemId, accountId })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.defaultErrorMessage),
      })
    }
  }

  return {
    commands: {
      correctAccountCode: handleCorrectAccountCode,
    },
    states: {
      isSaving: isLoading,
    },
  }
}
